import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



const router =  new Router({
  routes: [


    //管理平台
    { path: '*', component: () => import('../components/error/NotFoundComponent')},

    {path: '/', name: '',redirect:'/homePage', component: () => import('../components/home/home'),
 
      children: [
        {
          path: 'homePage',
          name: '首页',
          component: () => import('../views/homePage/homePage.vue')
        },
        {
          path: 'productSeach',
          name: '产品查询',
          component: () => import('../views/productSeach/productSeach.vue')
        },
        {
          path: 'produceCoun',
          name: '产品查询',
          component: () => import('../views/productSeach/productSeach1.vue')
        },
        {
          path: 'indicatorSeach',
          name: '指标查询',
          component: () => import('../views/indicatorSeach/indicatorSeach.vue')
        },
        {
          path: 'psCommunication',
          name: '科普交流',
          component: () => import('../views/psCommunication/psCommunication.vue')
        },
        {
          path: 'psCommunicationseach',
          name: '科普交流',
          component: () => import('../views/psCommunication/psCommunicationseach.vue')
        },
        {
          path: 'psCommunicationdetails',
          name: '科普交流详情',
          component: () => import('../views/psCommunication/psCommunicationdetails.vue')
        },
        {
          path: 'riskControl',
          name: '风险管控',
          component: () => import('../views/riskManagement/riskManagement.vue')
        },
        {
          path: 'riskManagementDetails',
          name: '风险管控详情',
          component: () => import('../views/riskManagement/details.vue')
        },
        {
          path: 'news',
          name: '新闻动态',
          component: () => import('../views/news/news.vue'),
          meta:{canKeep:true,name:'/news'}
        },
        {
          path: 'newsDetails',
          name: '新闻动态详情',
          component: () => import('../views/news/newsDetails.vue'),
          meta:{canKeep:true,name:'/news'}
        },
        {
          path: 'riskControl',
          name: '风险管控',
          component: () => import('../views/riskControl/riskControl.vue')
        },
        {
          path: 'industrialServices',
          name: '产业服务',
          component: () => import('../views/industrialServices/industrialServices.vue')
        },

        {
          path: 'aboutAs',
          name: '关于我们',
          component: () => import('../views/aboutAs/aboutAs.vue')
        },
        {
          path: 'productSeachDetails',
          name: '产品详情',
          component: () => import('../views/productSeach/productSeachDetails.vue')
        },
        {
          path: 'hlj',
          name: '区域特色',
          component: () => import('../views/charactQy/charactQy.vue')
        },
        
        {
          path: 'ProductList',
          name: '产品详情',
          component: () => import('../views/ProductList/ProductList.vue')
        }, 

        {
          path: 'gi',
          name: '地理标志产地',
          component: () => import('../views/Geographical/Geographical.vue')
        }, 
        {
          path: 'GeographicalDetails',
          name: '课题介绍详情',
          component: () => import('../views/Geographical/GeographicalDetails.vue')
        }, 
        {
          path: 'fcp',
          name: '蜂茶品',
          component: () => import('../views/fcp/fcp.vue')
        }, 
        {
          path: 'fcpMore',
          name: '蜂茶品',
          component: () => import('../views/fcp/fcpmore.vue')
        }, 
        {
          path: 'fuJian',
          name: '福建省专题',
          component: () => import('../views/fuJian/fuJian.vue')
        }, 
         {
          path: 'shangHai',
          name: '上海省专题',
          component: () => import('../views/shangHai/shangHai.vue')
        }, 
                {
          path: 'heNan',
          name: '河南省专题',
          component: () => import('../views/heNan/heNan.vue')
        },
        
      ]
    },
    {
      path: '/productSeachDetails1',
      name: '全国肉牛产品详情',
      component: () => import('../views/productSeach/productSeachDetails1.vue')
    },
    {
      path: '/between',
      name: '潍坊产品详情',
      component: () => import('../views/ProductList/between.vue')
    }, 
    {
      path: '/qgzyc',
      name: '全国中药材',
      redirect:'/qgzyc/home',
      component: () => import('../views/qgzycpz/qgzyc.vue'),
      children:[ 
        {
          path: 'home',
          name: '',
          component: () => import('../views/qgzycpz/home.vue')
        },
        
        {

          path: 'psCommunicationdetails1',
          name: '科普交流详情',
          component: () => import('../views/psCommunication/psCommunicationdetails.vue')
        },
        {
          path: 'productSeach1',
          name: '',
          component: () => import('../views/qgzycpz/productSeach.vue')
        },
        {
          path: 'ProductList1',
          name: '',
          component: () => import('../views/qgzycpz/ProductList.vue')
        }, 
        {
          path: 'indicatorSeach',
          name: '特征指标',
          component: () => import('../views/qgzycpz/indicatorSeach.vue')
        },
        {
          path: 'psCommunication',
          name: '科普交流',
          component: () => import('../views/qgzycpz/psCommunication.vue')
        },
        {
          path: 'psCommunicationdetails',
          name: '科普交流详情',
          component: () => import('../views/qgzycpz/psCommunicationdetails.vue')
        },
      ]
    }, 

    {
      path: '/wfncp',
      name: '山东省农产品品质特征库',
      redirect:'/wfncp/home',
      component: () => import('../views/weifang/wfncp.vue'),
      children:[ 
        {
          path: 'home',
          name: '',
          component: () => import('../views/weifang/home.vue')
        },
        
        {

          path: 'psCommunicationdetails1',
          name: '科普交流详情',
          component: () => import('../views/psCommunication/psCommunicationdetails.vue')
        },
        {
          path: 'productSeach1',
          name: '',
          component: () => import('../views/weifang/productSeach.vue')
        },
        {
          path: 'ProductList1',
          name: '',
          component: () => import('../views/weifang/ProductList.vue')
        }, 

        {
          path: 'indicatorSeach',
          name: '特征指标',
          component: () => import('../views/weifang/indicatorSeach.vue')
        },
        {
          path: 'psCommunication',
          name: '中欧互认产品',
          component: () => import('../views/weifang/psCommunication.vue')
        },
        {
          path: 'psCommunicationdetails',
          name: '科普交流详情',
          component: () => import('../views/weifang/psCommunicationdetails.vue')
        },
        {
          path: 'productSeachDetails',
          name: '产品详情',
          component: () => import('../views/weifang/productSeachDetails.vue')
        },

        
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },

  mode: 'history',
  // base: '/admin/'
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js